var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertMonarch4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 3C46.3594 3 58 14.6407 58 29C58 43.3594 46.3594 55 32 55C17.6406 55 6 43.3594 6 29C6 14.6407 17.6406 3 32 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6482 39.9301L30.8964 41.4181L30.2802 43.4821C27.0321 43.2901 23.4242 43.1861 19.4724 43.1861C14.8401 43.1861 11.2401 43.3539 8.68022 43.6741L8.34424 40.9381C8.8881 40.9381 9.28834 40.9702 9.53634 41.0341C9.85647 40.9702 10.2885 40.9381 10.8402 40.9381C12.2802 40.7861 13.6242 40.274 14.8643 39.41C16.1123 38.546 17.1842 37.4741 18.1041 36.1939C19.0161 34.9142 19.7202 33.5782 20.2161 32.1941C20.7124 30.8021 20.9604 29.5621 20.9604 28.4581C20.9604 26.9542 20.6001 25.6661 19.8722 24.5701C19.1522 23.4823 18.1362 22.9381 16.8324 22.9381C15.4962 23.0341 14.4243 23.5704 13.6163 24.5462C12.8082 25.5301 12.3921 26.8661 12.3684 28.5541C12.4005 28.8103 12.4163 29.1943 12.4163 29.6981H11.0243C11.0243 26.8343 11.6403 24.4661 12.8721 22.6021C14.0963 20.7384 15.9842 19.7621 18.5124 19.6741C19.6322 19.6741 20.6402 19.9462 21.5201 20.4821C22.3924 21.0181 23.0882 21.7781 23.592 22.7461C24.0962 23.7224 24.3683 24.8263 24.4163 26.0581C24.4163 27.4742 24.1922 28.7941 23.7522 30.0182C23.3124 31.25 22.7201 32.4019 21.9842 33.4901C21.2483 34.5862 20.4002 35.674 19.4322 36.7621C18.4722 37.8502 17.5444 38.9062 16.6482 39.9301Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8309 15.2516L37.607 26.6839L26.991 26.1048L36.0679 32.9474L32.2774 43.666L41.1114 36.4627L49.3843 43.666L45.7674 32.3716L54.6707 26.1048L43.6012 26.3283L40.8309 15.2516Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8309 15.2516L37.607 26.6839L26.991 26.1048L36.0679 32.9474L32.2774 43.666L41.1114 36.4627L49.3843 43.666L45.7674 32.3716L54.6707 26.1048L43.6012 26.3283L40.8309 15.2516Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44824 52.2347L1.22412 51.5948C2.09345 50.4934 2.90678 49.3573 3.66158 48.1842C4.41598 47.0133 5.14959 45.7653 5.86426 44.4428L7.08012 44.6322L6.75745 51.1307L9.01599 50.9708L8.6641 51.8533L6.66398 51.8855L6.51998 54.7946L5.31999 55.5146C5.46932 54.4026 5.54411 53.2107 5.54411 51.9467H4.8241C3.92276 51.9467 2.79491 52.0427 1.44824 52.2347ZM5.83211 45.7868L2.29346 51.1307H5.54411L5.83211 45.7868Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1371 45.9384C13.2555 45.9384 14.1622 46.9498 14.1622 48.197C14.1622 49.4446 13.2555 50.4557 12.1371 50.4557C11.0187 50.4557 10.1121 49.4446 10.1121 48.197C10.1121 46.9498 11.0187 45.9384 12.1371 45.9384Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1371 45.9384C13.2555 45.9384 14.1622 46.9498 14.1622 48.197C14.1622 49.4446 13.2555 50.4557 12.1371 50.4557C11.0187 50.4557 10.1121 49.4446 10.1121 48.197C10.1121 46.9498 11.0187 45.9384 12.1371 45.9384Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2149 54.1943H8.08691C8.08691 52.0438 9.93506 50.2999 12.2149 50.2999C14.4947 50.2999 16.3429 52.0438 16.3429 54.1943H12.2149Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2149 54.1943H8.08691C8.08691 52.0438 9.93506 50.2999 12.2149 50.2999C14.4947 50.2999 16.3429 52.0438 16.3429 54.1943H12.2149Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-532 -908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertMonarch4);
export default __webpack_public_path__ + "static/media/convert_monarch4.242b8788e3df81bcdec94eedf0412b62.svg";
export { ForwardRef as ReactComponent };